export default __webpack_public_path__ + "static/media/google.437a0b2c.png";